import { openExternalLink } from './openExternalLink';

export const navigateLink = (link, navigationContext) => {
  if(typeof(link) === 'string') {
    navigationContext.goNext(link);
  } else if(link.external) {
    openExternalLink(link);
  } else {
    if(typeof(link) === 'string')
      console.error('misconfigured link: ' + link);
    else
      console.error('misconfigured link: ' + JSON.stringify(link));
  }
}
